import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ibotsLogo from '../../assets/ibots-logo.png';

const STATES = ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Delhi','Jammu & Kashmir','Ladakh','Puducherry','Chandigarh'];

const css = `
* { box-sizing: border-box; }
.rp2-root {
  min-height: 100vh;
  display: flex;
  font-family: 'Nunito','Segoe UI',sans-serif;
}
.rp2-left {
  width: 44%;
  flex-shrink: 0;
  background: linear-gradient(160deg,#020d1f 0%,#0d2e6e 55%,#1e3a8a 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px 52px;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
}
.rp2-left::before {
  content:''; position:absolute; top:-100px; right:-100px;
  width:380px; height:380px; border-radius:50%;
  background:rgba(255,255,255,0.03);
}
.rp2-left::after {
  content:''; position:absolute; bottom:-80px; left:-80px;
  width:300px; height:300px; border-radius:50%;
  background:rgba(37,99,235,0.12);
}
.rp2-logo { height: 48px; object-fit: contain;  margin-bottom: 52px; }
.rp2-tag {
  display: inline-flex; align-items: center; gap: 8px;
  background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.18);
  border-radius: 20px; padding: 5px 14px;
  font-size: 11px; font-weight: 700; color: rgba(255,255,255,0.8);
  letter-spacing: 0.6px; margin-bottom: 22px;
}
.rp2-tag-dot { width:7px; height:7px; border-radius:50%; background:#22c55e; }
.rp2-title {
  font-size: 38px; font-weight: 900; color: #fff;
  line-height: 1.15; margin: 0 0 18px;
}
.rp2-title span { color: #60a5fa; }
.rp2-desc {
  font-size: 14px; color: rgba(255,255,255,0.6);
  line-height: 1.75; margin: 0 0 44px;
}
.rp2-feats { display: flex; flex-direction: column; gap: 13px; }
.rp2-feat { display: flex; align-items: center; gap: 11px; font-size: 13.5px; color: rgba(255,255,255,0.75); }
.rp2-feat-dot { width:8px; height:8px; border-radius:50%; background:#60a5fa; flex-shrink:0; }
.rp2-right {
  flex: 1;
  background: #f4f7fc;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 48px 52px;
  overflow-y: auto;
}
.rp2-form-wrap {
  width: 100%;
  max-width: 560px;
}
.rp2-form-title { font-size: 28px; font-weight: 900; color: #0d2e6e; margin: 0 0 6px; }
.rp2-form-sub { font-size: 13.5px; color: #94a3b8; margin: 0 0 32px; line-height: 1.5; }
.rp2-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.rp2-full { grid-column: 1 / -1; }
.rp2-fld { display: flex; flex-direction: column; gap: 6px; }
.rp2-lbl { font-size: 11.5px; font-weight: 800; color: #475569; text-transform: uppercase; letter-spacing: 0.5px; }
.rp2-req { color: #e8394d; margin-left: 2px; }
.rp2-inp-wrap {
  display: flex; align-items: center;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  padding: 11px 14px; gap: 9px; background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.rp2-inp-wrap:focus-within {
  border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37,99,235,0.09);
}
.rp2-inp-wrap input,
.rp2-inp-wrap select {
  border: none; outline: none; flex: 1;
  font-size: 13.5px; color: #0f172a;
  font-family: 'Nunito','Segoe UI',sans-serif;
  background: transparent;
}
.rp2-inp-wrap select { cursor: pointer; }
.rp2-inp-wrap svg { color: #94a3b8; flex-shrink: 0; }
.rp2-eye { background: transparent; border: none; cursor: pointer; color: #94a3b8; padding: 0; display: flex; }
.rp2-type-row { display: grid; grid-template-columns: repeat(3,1fr); gap: 10px; }
.rp2-type-btn {
  border: 1.5px solid #e2e8f0; border-radius: 9px;
  padding: 10px 6px; text-align: center; cursor: pointer;
  font-size: 12.5px; font-weight: 700; color: #64748b;
  background: #fff; transition: all 0.13s;
  font-family: 'Nunito','Segoe UI',sans-serif;
}
.rp2-type-btn.on { border-color: #2563eb; background: #eff6ff; color: #1d4ed8; }
.rp2-err {
  grid-column: 1 / -1;
  background: #fff5f5; border: 1px solid #fecaca;
  border-radius: 9px; padding: 10px 14px;
  font-size: 12.5px; color: #dc2626;
}
.rp2-btn {
  grid-column: 1 / -1;
  height: 50px;
  background: linear-gradient(135deg,#2563eb,#1e3a8a);
  color: #fff; border: none; border-radius: 11px;
  font-size: 15px; font-weight: 900;
  font-family: 'Nunito','Segoe UI',sans-serif;
  cursor: pointer; letter-spacing: 0.03em;
  transition: opacity 0.15s, transform 0.15s;
  margin-top: 4px;
}
.rp2-btn:hover { opacity: 0.9; transform: translateY(-1px); }
.rp2-btn:disabled { opacity: 0.65; cursor: not-allowed; transform: none; }
.rp2-bottom {
  grid-column: 1 / -1;
  text-align: center; font-size: 13px; color: #64748b; margin-top: 4px;
}
.rp2-bottom a { color: #2563eb; font-weight: 700; text-decoration: none; cursor: pointer; }
.rp2-bottom a:hover { text-decoration: underline; }
@media (max-width: 860px) { .rp2-left { display: none; } .rp2-right { padding: 32px 24px; } }
@media (max-width: 520px) { .rp2-grid { grid-template-columns: 1fr; } .rp2-type-row { grid-template-columns: 1fr 1fr; } }
`;

const Svg = {
  person: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  mail:   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  phone:  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.38 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.27a16 16 0 0 0 8 8l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 23.73 18z"/></svg>,
  map:    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  school: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  lock:   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
};

const EyeBtn = ({ show, toggle }) => (
  <button type="button" className="rp2-eye" onClick={toggle}>
    {show
      ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
      : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>}
  </button>
);

export default function RegisterPage() {
  const navigate = useNavigate();
  const [f, setF] = useState({ name:'', email:'', phone:'', password:'', confirm:'', type:'School Student', institution:'', city:'', state:'', gradeOrYear:'' });
  const [sp, setSp] = useState(false);
  const [sc, setSc] = useState(false);
  const [err, setErr] = useState('');
  const [ld, setLd]   = useState(false);

  useEffect(() => {
    if (!document.getElementById('rp2-css')) {
      const t = document.createElement('style');
      t.id = 'rp2-css'; t.textContent = css;
      document.head.appendChild(t);
    }
  }, []);

  const set = (k,v) => setF(p => ({ ...p, [k]:v }));

  const submit = async (e) => {
    e.preventDefault(); setErr('');
    if (!f.name||!f.email||!f.phone||!f.password||!f.confirm||!f.city||!f.state)
      { setErr('Please fill in all required fields.'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email))
      { setErr('Enter a valid email address.'); return; }
    if (f.password.length < 6)
      { setErr('Password must be at least 6 characters.'); return; }
    if (f.password !== f.confirm)
      { setErr('Passwords do not match.'); return; }
    setLd(true);
    try {
      const r = await fetch('http://localhost:5000/api/users/register', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ name:f.name.trim(), email:f.email.trim(), phone:f.phone.trim(), password:f.password, type:f.type, institution:f.institution.trim(), city:f.city.trim(), state:f.state, gradeOrYear:f.gradeOrYear.trim() }),
      });
      const d = await r.json();
      if (!r.ok) { setErr(d.message||'Registration failed.'); return; }
      localStorage.setItem('ibots_user_token', d.token);
      localStorage.setItem('ibots_user', JSON.stringify(d.user));
      window.dispatchEvent(new Event('ibots_user_updated'));
      navigate('/my-account');
    } catch { setErr('Cannot reach server. Make sure backend is running.'); }
    finally { setLd(false); }
  };

  const isSchool = f.type === 'School Student';

  return (
    <div className="rp2-root">
      <div className="rp2-left">
        <img  src={ibotsLogo} alt="iBots" className="rp2-logo" />
        <div className="rp2-tag"><span className="rp2-tag-dot"/>INDIA'S ROBOTICS TRAINING PLATFORM</div>
        <h1 className="rp2-title">Start Your<br/><span>Innovation</span><br/>Journey Today.</h1>
        <p className="rp2-desc">Join thousands of students learning robotics, electronics, AI and IoT with iBots — India's leading STEM training institute.</p>
        <div className="rp2-feats">
          {['Track your enrolled courses','Get personalised learning updates','Access workshop registrations','Manage demo session bookings','Earn industry-recognised certificates'].map(t => (
            <div className="rp2-feat" key={t}><span className="rp2-feat-dot"/>{t}</div>
          ))}
        </div>
      </div>

      <div className="rp2-right">
        <div className="rp2-form-wrap">
          <div className="rp2-form-title">Create your account</div>
          <div className="rp2-form-sub">Join the iBots community and start tracking your learning journey.</div>

          <form className="rp2-grid" onSubmit={submit}>

            <div className="rp2-fld">
              <label className="rp2-lbl">Full Name <span className="rp2-req">*</span></label>
              <div className="rp2-inp-wrap">{Svg.person}<input value={f.name} onChange={e=>set('name',e.target.value)} placeholder="Your full name" required /></div>
            </div>
            <div className="rp2-fld">
              <label className="rp2-lbl">Phone <span className="rp2-req">*</span></label>
              <div className="rp2-inp-wrap">{Svg.phone}<input value={f.phone} onChange={e=>set('phone',e.target.value)} placeholder="+91 XXXXX XXXXX" type="tel" required /></div>
            </div>

            <div className="rp2-fld rp2-full">
              <label className="rp2-lbl">Email Address <span className="rp2-req">*</span></label>
              <div className="rp2-inp-wrap">{Svg.mail}<input value={f.email} onChange={e=>set('email',e.target.value)} placeholder="you@email.com" type="email" required /></div>
            </div>

            <div className="rp2-fld rp2-full">
              <label className="rp2-lbl">I am a <span className="rp2-req">*</span></label>
              <div className="rp2-type-row">
                {['School Student','College Student','Professional'].map(t => (
                  <button key={t} type="button" className={'rp2-type-btn'+(f.type===t?' on':'')} onClick={()=>set('type',t)}>{t}</button>
                ))}
              </div>
            </div>

            <div className="rp2-fld rp2-full">
              <label className="rp2-lbl">{isSchool ? 'School Name' : f.type==='Professional' ? 'Organisation Name' : 'College / University Name'}</label>
              <div className="rp2-inp-wrap">{Svg.school}<input value={f.institution} onChange={e=>set('institution',e.target.value)} placeholder={isSchool?'Name of your school':'Name of your college / organisation'} /></div>
            </div>

            <div className="rp2-fld">
              <label className="rp2-lbl">{isSchool ? 'Grade / Standard' : f.type==='Professional' ? 'Designation' : 'Year / Semester'}</label>
              <div className="rp2-inp-wrap">{Svg.person}<input value={f.gradeOrYear} onChange={e=>set('gradeOrYear',e.target.value)} placeholder={isSchool?'e.g. Grade 9':f.type==='Professional'?'e.g. Software Engineer':'e.g. 2nd Year'} /></div>
            </div>
            <div className="rp2-fld">
              <label className="rp2-lbl">City <span className="rp2-req">*</span></label>
              <div className="rp2-inp-wrap">{Svg.map}<input value={f.city} onChange={e=>set('city',e.target.value)} placeholder="Your city" required /></div>
            </div>

            <div className="rp2-fld rp2-full">
              <label className="rp2-lbl">State <span className="rp2-req">*</span></label>
              <div className="rp2-inp-wrap">{Svg.map}
                <select value={f.state} onChange={e=>set('state',e.target.value)} required>
                  <option value="">— Select your state —</option>
                  {STATES.map(s=><option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>

            <div className="rp2-fld">
              <label className="rp2-lbl">Password <span className="rp2-req">*</span></label>
              <div className="rp2-inp-wrap">{Svg.lock}<input type={sp?'text':'password'} value={f.password} onChange={e=>set('password',e.target.value)} placeholder="Min. 6 characters" required /><EyeBtn show={sp} toggle={()=>setSp(s=>!s)}/></div>
            </div>
            <div className="rp2-fld">
              <label className="rp2-lbl">Confirm Password <span className="rp2-req">*</span></label>
              <div className="rp2-inp-wrap">{Svg.lock}<input type={sc?'text':'password'} value={f.confirm} onChange={e=>set('confirm',e.target.value)} placeholder="Re-enter password" required /><EyeBtn show={sc} toggle={()=>setSc(s=>!s)}/></div>
            </div>

            {err && <div className="rp2-err">{err}</div>}
            <button type="submit" className="rp2-btn" disabled={ld}>{ld?'Creating account...':'Create Account →'}</button>
            <div className="rp2-bottom">Already have an account? <a onClick={()=>{navigate('/');window.dispatchEvent(new Event('ibots_open_login'));}}>Sign in</a></div>
          </form>
        </div>
      </div>
    </div>
  );
}
